var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingProviderApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560.83 581.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ee7404;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.8,298.09c-3.13,.01-6.1,.09-8.9,.25h-16.79c-4.47-.19-8.65-.28-12.58-.25-3.86,.01-7.47,.13-10.81,.37-30.87,2.22-41.44,14.54-43.56,48.01-.01,.15-.02,.3-.03,.46h-89.82c-110.96-4.66-128.56,22.03-124.47,146.85v87.45H0v-150.82c0-81.1,54.29-135.5,135.27-135.5h197.85c11.46,0,22.38,1.09,32.68,3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    className: "cls-1",
    d: "M235.06,267.92c-74.19-.04-134.29-60.22-134.25-134.4,.03-53.93,32.31-102.61,81.98-123.63,68.74-27.89,147.08,5.23,174.97,73.97,27.34,67.38-3.9,144.27-70.48,173.5-16.52,7-34.28,10.59-52.22,10.56Zm0-208.9c-41.2,0-74.61,33.4-74.61,74.61s33.4,74.61,74.61,74.61,74.61-33.4,74.61-74.61c-.04-41.19-33.42-74.56-74.61-74.61Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M406.53,270.3h.01s0,0,0,0h-.01Zm87.23,85.14s.02,.02,.02,.02v-.02h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.76,355.44c-2.71-2.68-5.5-5.55-8.43-8.59l-69.41-67.77c-3.33-3.05-6.45-5.96-9.38-8.77h-.01s-92.31-.01-92.31-.01c-24.26,0-44.08,9.06-56.9,24.61-10.25,12.42-16.03,29.01-16.03,48.43v165.32c0,43.71,29.27,73.04,72.93,73.04h106.64c1.67,0,3.29-.04,4.92-.13,1.46-.07,2.9-.2,4.33-.34h.01c6.97-.7,13.51-2.19,19.53-4.41,12.76-4.69,23.24-12.63,30.78-23.16,.04-.03,.06-.07,.08-.11,.41-.57,.81-1.14,1.2-1.73-1.45,.12-2.9,.18-4.37,.18-10.6,0-20.49-3.05-28.83-8.32-4.63,4.07-10.65,6.74-18.39,8.31-1.38,.3-2.84,.55-4.34,.77-2.83,.42-5.88,.71-9.13,.9-.43,.03-.89,.05-1.34,.07-5.03,.24-10.57,.25-16.69,.06-6.64,.21-12.63,.18-18.03-.13h-40.48c-8.87,.37-16.62,.37-23.39-.12-38.98-2.8-45.59-21.73-43.71-79.04v-97c-.38-11.73-.42-21.86,.12-30.57,.01-.16,.02-.31,.03-.46,2.12-33.47,12.69-45.79,43.56-48.01,3.34-.24,6.95-.36,10.81-.37,3.93-.03,8.11,.06,12.58,.25h34.71v12.1c0,2.43,.09,4.81,.27,7.14,2.34,30.83,19.97,53.5,47.02,62.1,7.81,2.49,16.4,3.8,25.63,3.8h14.38v62.45c4.84-1.41,9.94-2.17,15.22-2.17,5.73,0,11.25,.89,16.44,2.54v-90.84s-.02,0-.02-.02Zm-86.38-40.37l41.08,40.11c-27.04-2.35-37.86-13.05-41.08-40.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.76,355.44s.02,.02,.02,.02v-.02h-.02Zm-87.23-85.14h.01s0,0,0,0h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3-2",
    "data-name": "Subtraction 3",
    className: "cls-1",
    d: "M445.16,420.25c-2.34,.99-4.62,2.08-6.83,3.26h0s-.01,0-.01,0c-8.48,4.52-15.99,10.4-22.31,17.29h22.31v19.57c6.46-6.71,14.63-11.76,23.8-14.45v-30.58c-5.7,1.01-11.38,2.64-16.96,4.9Zm109.75,47c-.08-.24-.17-.47-.28-.72-2.24-5.51-4.99-10.65-8.17-15.4-8.55-12.7-20.23-22.54-33.57-28.88-6.08-2.9-12.5-5.07-19.11-6.43-10.27-2.14-21-2.37-31.66-.47-5.7,1.01-11.38,2.64-16.96,4.9-2.34,.99-4.62,2.08-6.83,3.26h0s-.01,0-.01,0c-8.48,4.52-15.99,10.4-22.31,17.29-1.37,1.48-2.67,3-3.92,4.57-5.87,7.41-10.5,15.79-13.6,24.79-3,8.68-4.63,17.93-4.63,27.43,0,2.76,.13,5.48,.38,8.17,1.77,18.35,9.42,34.98,21.07,47.96,9.25,10.32,21.02,18.34,34.34,23.09,8.82,3.15,18.32,4.87,28.21,4.88,11.23,0,22.34-2.24,32.68-6.61,1.11-.49,2.22-1.01,3.3-1.56,12.38-6.06,22.65-14.81,30.39-25.26,.98-1.31,1.9-2.64,2.78-4,14.52-22.13,18.33-50.68,7.9-77.02Zm-73.2,84.57c-1.45,.12-2.9,.18-4.37,.18-10.6,0-20.49-3.05-28.83-8.32-15.2-9.58-25.28-26.51-25.28-45.8,0-10.12,2.78-19.6,7.61-27.71,2.13-3.55,4.64-6.83,7.48-9.79,6.46-6.71,14.63-11.76,23.8-14.45,4.84-1.41,9.94-2.17,15.22-2.17,5.73,0,11.25,.89,16.44,2.54,21.85,6.96,37.69,27.42,37.69,51.58,0,28.42-21.92,51.72-49.76,53.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 292.59,
    y: 394.16,
    width: 145.73,
    height: 29.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M438.32,440.81v19.57c-2.85,2.96-5.36,6.24-7.48,9.79h-138.25v-29.36h145.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 292.59,
    y: 486.28,
    width: 59.97,
    height: 29.36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 464.54,
    y: 453.11,
    width: 25.6,
    height: 53.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 464.54,
    y: 517.03,
    width: 25.6,
    height: 25.6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingProviderApproval);
export default __webpack_public_path__ + "static/media/pendingProviderApproval.fc835c514099e03930d8c780b1053bc1.svg";
export { ForwardRef as ReactComponent };